
import { put, takeEvery } from 'redux-saga/effects'

export const SELECT_QUERY = 'search/ui/SELECT_QUERY';
export const SET_ATTR_CONDITION = 'search/ui/SET_ATTR_CONDITION';
export const SET_GEOM_CONDITION = 'search/ui/SET_GEOM_CONDITION';
export const SET_IS_GEO_ACTIVE = 'search/ui/SET_IS_GEO_ACTIVE';
export const SET_IS_VALID = 'search/ui/SET_IS_VALID';
export const SET_PARAM_VALUE = 'search/ui/SET_PARAM_VALUE';

import { CLEAR_SEARCH_RESULT } from './search';

export default function getActions(dispatch) {
    return {
        selectQuery: (queryId, queryType) => dispatch({
            type: SELECT_QUERY,
            queryId, queryType
        }),
        setAttrCondition: (attrId, condition) => dispatch({
            type: SET_ATTR_CONDITION,
            attrId, condition
        }),
        setGeomCondition: (geometry, condition) => dispatch({
            type: SET_GEOM_CONDITION,
            geometry, condition
        }),
        setIsGeoActive: (active) => dispatch({
            type: SET_IS_GEO_ACTIVE,
            active
        }),
        setIsValid: (isValid) => dispatch({
            type: SET_IS_VALID,
            isValid
        }),
        setParamValue: (paramId, value) => dispatch({
            type: SET_PARAM_VALUE,
            paramId, value
        })
    };
}

function* workSelectQuery(action) {
    yield put({
        type: CLEAR_SEARCH_RESULT
    });
}

export function* watchSelectQuery() {
    yield takeEvery(SELECT_QUERY, workSelectQuery);
}
